@import (reference) '../../../../../../constants/spacing.module.less';

.promo-card {
  position: relative;
  margin: -@space-16;
  margin-right: 0;
  padding: @space-16;
  padding-left: 90px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -60px;
    width: 130px;
    height: 100%;
    background-color: var(--grey-200);
    mask-image: url('../../../../../../app-brand/logo/shipstation-logo-mark.svg');
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  }
}

.promo-headline {
  font-weight: 600;
  line-height: 1.4;
}

.promo-body {
  margin-top: @space-8;
  color: var(--grey-700);
  line-height: 1.5;
}

.promo-links {
  margin-top: @space-16;
}

.promo-links a {
  font-size: 14px;
  color: var(--blue-600);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: @space-4;
}

.promo-links a:hover {
  text-decoration: underline;
}

.external-link-icon {
  height: 12px;
  width: 12px;
}
